<script setup lang="ts">
import { onMounted, useTemplateRef, watch } from 'vue'

import { useElementSize } from '@vueuse/core'

type Emits = { itemWidth: [number] }
const emit = defineEmits<Emits>()

// state
const carouselItemElement = useTemplateRef('carouselItemElement')
const { width: itemWidth } = useElementSize(carouselItemElement)

// init
onMounted(() => {
  emit('itemWidth', itemWidth.value + 0.375 * 16) // 0.375rem * 16px
})

// watch
watch(itemWidth, (newWidth) => {
  emit('itemWidth', newWidth)
})
</script>

<template>
  <span
    ref="carouselItemElement"
    class="shrink-0"
  >
    <slot />
  </span>
</template>
